import { render } from "./language-screen.vue?vue&type=template&id=0f4efe21&scoped=true"
import script from "./language-screen.vue?vue&type=script&lang=js"
export * from "./language-screen.vue?vue&type=script&lang=js"

import "./language-screen.vue?vue&type=style&index=0&id=0f4efe21&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4efe21"],['__file',"src/components/language-screen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f4efe21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f4efe21', __exports__)) {
    api.reload('0f4efe21', __exports__)
  }
  
  module.hot.accept("./language-screen.vue?vue&type=template&id=0f4efe21&scoped=true", () => {
    api.rerender('0f4efe21', render)
  })

}


export default __exports__